import { render, staticRenderFns } from "./dtlMain.vue?vue&type=template&id=354dfb5b&scoped=true"
import script from "./dtlMain.vue?vue&type=script&lang=js"
export * from "./dtlMain.vue?vue&type=script&lang=js"
import style0 from "./dtlMain.vue?vue&type=style&index=0&id=354dfb5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354dfb5b",
  null
  
)

export default component.exports